import React from "react";
import "./modal.component.scss"

const Modal = () => {
    return (
        <div className={"xpl-modal"}></div>
    );
}

export default Modal;